/**
 * Licensed Materials - Property of IBM
 * IBM Watson Analytics (C) Copyright IBM Corp. 2018
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

class BaseStep {
	constructor(options, moduleOptions) {
		this.chartInsightsFeature = moduleOptions.chartInsightsFeature;
		this.id = options.id;
		this.owner = options.owner;
		this.ownerWidget = options.ownerWidget;
		this.logger = options.logger;
		this.visAPI = options.visAPI;
		this.dashboardApi = options.dashboardApi;

		this._initializeStep = this.owner && this.owner._initializeStep.bind(this.owner);
		this._isStepComplete = this.owner && this.owner._isStepComplete.bind(this.owner);
		this._completeStep = this.owner && this.owner._completeStep.bind(this.owner);
		this._logRenderContext = this.owner && this.owner._logRenderContext.bind(this.owner);

		if (this.id && this._initializeStep) {
			this._initializeStep(this.id);
		}


	}

	getRenderState() {
		return this.owner && this.owner._renderState;
	}

	clearError() {
		this.visAPI && this.visAPI.visHelper.clearError();
	}

	showError(msg, params) {
		this.visAPI && this.visAPI.visHelper && this.visAPI.visHelper.showError(msg, params);
	}

}

export default BaseStep;



// WEBPACK FOOTER //
// ./src/js/features/insights/rendersequence/BaseStep.js